import { BRAND } from "./constants";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  // relative path like /api/static/... -> prefix with backend URL
  return `${BACKEND_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

export function whatsappLink(message) {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${BRAND.whatsappNumber}?text=${encoded}`;
}

export function orderMessage(product) {
  return `Hi OVI — I'd like to order "${product.name}" by ${product.maker_first_name} from ${product.maker_city}. Price: ₹${product.price_inr}. Please share availability and delivery timeline.`;
}

export function generalMessage() {
  return `Hi OVI — I'd like to know more about your products from Solapur.`;
}

export function formatINR(n) {
  if (typeof n !== "number") n = Number(n) || 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
}
